module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAeFBMVEUAAAD////j4+PR0dHMzMzX19fb29vZ2dnb29vb29vX19fY2NjZ2dnY2NjZ2dnX19fZ2dnX19fZ2dnY2NjZ2dnY2NjZ2dnZ2dnZ2dnY2NjY2NjZ2dnY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NhJGW/EAAAAJ3RSTlMAAgkLDxMjKD9ARlVdaWpzhZOTl5mluru8zdjc3+Dh4+bt7vH3+f0euUN9AAAAj0lEQVQoz+XOVxLCMAxFURFK6ITeW4Jh/zskfh4JPW8BfenM9WgsHzfSDvkPY8hi8KizWHvcswiLnIGT6JAvwMEi+QGsLZIbYGHRu0gfGGsjl9hfhUbyBNjZVfIKmFv07tzi/uxqI6crVXY1uY+H154278Ex7u+RNvIW+8yOkiPCVCiaW+xLofjzcjMUP85fvtFGeUi6gaAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_yueban_right.png
// module id = TV+m
// module chunks = 2